import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    body: "Poppins, sans-serif", // Set Poppins as the default font for body text
    heading: "Poppins, sans-serif", // Set Poppins as the default font for headings
  },
  components: {
    Input: {
      baseStyle: {
        fontFamily: "Poppins, sans-serif", // Set Poppins as the font for Input component
      },
    },
  },
});

export default theme;
